import React, { useEffect, useState } from "react";
import "./loading_component.css";

function LoadingComponent() {
  const MAX_DOTS = 7;

  const [dotCount, setDotCount] = useState(0);
  const [increasing, setIncreasing] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setDotCount((prev) => {
        if (increasing) {
          if (prev >= MAX_DOTS) {
            setIncreasing(false);
            return prev - 1;
          }
          return prev + 1;
        }

        if (prev <= 0) {
          setIncreasing(true);
          return prev + 1;
        }

        return prev - 1;
      });
    }, 200);

    return () => clearInterval(interval);
  }, [increasing]);

  return (
    <div className="state">
      <div className="state-container">
        <div className="state-card">
          <h2>Carregando{". ".repeat(dotCount)}</h2>

          <img
            src="/loading_lesson.png"
            alt="Carregando informações..."
            className="state-image"
          />
        </div>
      </div>
    </div>
  );
}

export default LoadingComponent;